var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-8368.209,3430.536l1.347,1.347,1.347,1.347-2.693,2.693","transform":"translate(8369.623 -3429.122)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"2"}));
}

Arrow.defaultProps = {"width":"5.521","height":"8.215","viewBox":"0 0 5.521 8.215"};

module.exports = Arrow;

Arrow.default = Arrow;
